import { AutogenModelDistanceSource, AutogenRowDistanceSource } from "./autogen/AutogenModelDistanceSource";

export class ModelDistanceSource extends AutogenModelDistanceSource<RowDistanceSource> {
	constructor() {
		super(RowDistanceSource);
	}
}

export class RowDistanceSource extends AutogenRowDistanceSource {
}